module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/IoeBqF/images/Cover.jpg?1693741290160",
      "alt": "This image is the cover for the book Black Cowboys and Early Cattle Drives"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Black Cowboys and Early Cattle Drives\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Dust and Determination After the Civil War, emancipated slaves who didn't want to pick cotton or operate an elevator headed west to find work and a new life. Charles Goodnight and Oliver Loving drove two thousand longhorns across southern Texas blazing a trail to Bosque Redondo in New Mexico. In 1866, the new Goodnight-Loving Trail was crowded with cattle headed for a government market. By the 1870s, twenty-five percent of the over thirty-five thousand cowboys in the West were black. They were part of trail crews that drove more than twenty-seven million cattle on the Goodnight-Loving Trail, Western Trail, Chisholm Trail and Shawnee Trail. They were paid equally, and their skill and ability brought them earned respect and prestige. Author Nancy Williams recounts their lasting legacy.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mrs. Nancy K. Williams\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Exploring mountains, old abandoned mining camps and deserted diggings has always fascinated Nancy. A lifetime in the West has given her plenty of opportunities to learn about the many different people who struggled to carve out their lives amid its beauty and massive challenges. She is the author of Buffalo Soldiers on the Colorado Frontier , as well as three books on haunted hotels in California Gold Country, Northern Colorado and Southern Colorado.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0